@if (canDisplay()) {
  <div class="fx-column">
    @if (labelOutside() && label()) {
      <span class="label">{{ label() }}</span>
    }
    <div class="button" [class.active]="selection() !== undefined" style="max-width:100%;"
         [cdkMenuTriggerFor]="disabled() ? null : menu" #trigger="cdkMenuTriggerFor" [class.disabled]="disabled()">
      <div class="fx-row fx-flex-100 align-items-center justify-content-between label-container">
        @if (selection()) {
          <div class="text main left fx-flex">{{ selection() }}</div>
        } @else {
          <div class="text left fx-flex">{{ label() }}</div>
        }
        @if (!selection()) {
          <mat-icon class="dark ml-5" fontSet="material-icons-outlined">expand_more</mat-icon>
        } @else {
          <mat-icon class="main ml-5" fontSet="material-icons-outlined"
                    (click)="$event.stopPropagation(); onClear()">clear
          </mat-icon>
        }
      </div>
    </div>
    <ng-template #menu>
      <mat-card class="menu-container p-0 elevation" cdkMenu>
        <div class="fx-column" (click)="$event.stopPropagation()">
          <div>
            <div class="p-16">
              @if (label()) {
                <span class="text bold">{{ label()! | translate }}</span>
              }
              @if (search()) {
                <app-input placeholder="{{'ACTIONS.SEARCH' | translate}}..." type="text" prefix="search" class="mt-10"
                           [value]="query()" (valueChange)="query.set($event)" (change)="onQueryChange()"
                           [autoFocus]="true"></app-input>
              }
            </div>
            <mat-divider></mat-divider>
          </div>
          <div class="options-container" [scrollWindow]="false" [class.search]="search()" infiniteScroll
               [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50" (scrolled)="onScroll()">
            <div class="fx-column">
              @for (batch of batches().docs; track batch._id) {
                <div class="fx-row align-items-center justify-content-start clickable option actionable p-10"
                     [class.selected]="batch.selected" (click)="batch.disabled ? null : select(batch)"
                     [class.disabled]="batch.disabled">
                  <div class="fx-column align-items-start justify-content-start ml-5">
                    <span class="text option-label">{{ batchLabel(batch) }}</span>
                  </div>
                </div>
              } @empty {
                <div class="p-16">
                  <span class="light text">{{ 'PAGINATOR.GENERIC_SEARCH_NO_RESULTS' | translate }}</span>
                </div>
              }
            </div>
          </div>
        </div>
        <app-progress-bar [mode]="'indeterminate'" [loading]="loading()"></app-progress-bar>
      </mat-card>
    </ng-template>
  </div>
}
